module.exports = "/images/vendor/flag-icon-css/flags/1x1/yt.svg?b6042b9cfb432f844e964ddb24b4f341";